import { Clock } from "lucide-react";
import { useNavigation } from "@/contexts/NavigationContext";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ConversationList } from "./ConversationList";
import { supabase } from "@/integrations/supabase/client";

export const SidebarSectionHistory = () => {
  const {
    navigateToPersonal,
    navigateToProject,
    navigateToGlobal,
    navigateToTab,
    activeConversationId,
    setActiveConversationId,
    setActiveAgentId,
    skipNextConversationReset,
  } = useNavigation();

  return (
    <AccordionItem value="historico" className="border-none">
      <AccordionTrigger className="text-xs font-medium text-tertiary uppercase px-3 py-1.5 hover:no-underline hover:bg-hover rounded-md flex-row-reverse justify-end gap-1.5 [&>svg]:text-tertiary [&>svg]:w-3 [&>svg]:h-3">
        <span className="flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5" /> Histórico
        </span>
      </AccordionTrigger>
      <AccordionContent className="pb-0 pt-1 pl-4">
        <ConversationList
          projectId={undefined}
          activeConversationId={activeConversationId}
          setActiveConversationId={setActiveConversationId}
          onBeforeSelect={async (conv: any) => {
            skipNextConversationReset.current = true;
            setActiveAgentId(conv?.agent_id ?? null);
            if (conv?.project_id) {
              // Detect whether the project belongs to the Personal or Global space
              // so the sidebar highlights/expands the correct section and agent
              // inheritance (personal vs global) is resolved correctly.
              const { data: project } = await supabase
                .from('projects')
                .select('scope_type')
                .eq('id', conv.project_id)
                .maybeSingle();
              const isPersonalProject = project?.scope_type === 'personal';
              navigateToProject(conv.project_id, isPersonalProject);
            } else if (conv?.scope === 'global') {
              navigateToGlobal();
            } else {
              navigateToPersonal();
            }
          }}
          navigateToTab={navigateToTab}
          useGreenHighlight={false}
          fetchAll={true}
        />
      </AccordionContent>
    </AccordionItem>
  );
};
